import { render, staticRenderFns } from "./trip_reports.vue?vue&type=template&id=5fff867e&scoped=true&"
import script from "./trip_reports.vue?vue&type=script&lang=js&"
export * from "./trip_reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff867e",
  null
  
)

export default component.exports